import {
  Box,
  Paper,
  Typography,
  Chip,
  Divider,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { useLoaderData } from "react-router-dom";
import { Result } from "../../types/Result";
import { SystemLog } from "./type";

const LogLevelChip = ({ level }: { level: string }) => {
  const getColor = () => {
    switch (level.toLowerCase()) {
      case "error":
        return "error";
      case "warning":
        return "warning";
      case "info":
        return "info";
      default:
        return "default";
    }
  };

  return (
    <Chip
      label={level}
      color={getColor()}
      size="small"
      sx={{ fontWeight: "bold" }}
    />
  );
};

const LogDetailItem = ({
  label,
  content,
}: {
  label: string;
  content: string | null;
}) => {
  if (!content) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {label}
      </Typography>
      <Typography
        variant="body2"
        component="pre"
        sx={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          p: 2,
          borderRadius: 1,
          fontFamily: "monospace",
        }}
      >
        {content}
      </Typography>
    </Box>
  );
};

export default function LogForm() {
  const data = useLoaderData() as Result<SystemLog>;
  const log = data.data!;

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Card elevation={3}>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center" mb={2}>
            <LogLevelChip level={log.logLevel} />
            <Typography variant="caption" color="text.secondary">
              {new Date(log.timestamp).toLocaleString()}
            </Typography>
            {log.userId && (
              <Typography variant="caption" color="text.secondary">
                Kullanıcı: {log.userId}
              </Typography>
            )}
          </Stack>

          <Typography variant="h6" gutterBottom>
            {log.message}
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Stack spacing={3}>
            <LogDetailItem label="Source" content={log.source} />
            <LogDetailItem label="Exception" content={log.exception} />
            <LogDetailItem label="Stack Trace" content={log.stackTrace} />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
